<ods-select
  #select
  [class.invalid]="errorMessage && (!disabled && showErrorMessage || (dirty && touched && !selectedValue))"
  [label]="label"
  [placeholder]="placeholder"
  [disabled]="disabled"
  [attr.aria-label]="ariaLabel"
  [attr.aria-disabled]="disabled"
  [value]="selectedValue"
  (focus)="markAsTouched()"
  (change)="selectionChanged($event.target.value)"
>
  <ods-select-option *ngFor="let option of options" [value]="option.value">{{ option.label }}</ods-select-option>
</ods-select>

<p *ngIf="errorMessage && (!disabled && showErrorMessage || (dirty && touched && !selectedValue))" class="error-message">{{ errorMessage }}</p>

